module.exports = __webpack_public_path__ + "img/Jenna-Wong.66f21395.jpg";